import { useId } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

type DateFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  hint?: string;
};

/** A calendar date (YYYY-MM-DD) input; the business unit's timezone applies. */
export function DateField({
  label,
  value,
  onChange,
  error,
  hint,
}: DateFieldProps) {
  const id = useId();
  const messageId = `${id}-message`;
  const message = error ?? hint;

  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type="date"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-invalid={Boolean(error)}
        aria-describedby={message ? messageId : undefined}
      />
      {message && (
        <p
          id={messageId}
          className={error ? "text-sm text-red-600" : "text-sm text-slate-500"}
        >
          {message}
        </p>
      )}
    </div>
  );
}
